import * as React from 'react'
import { HoverCard,HoverCardContent,HoverCardTrigger } from '@/components/ui/hover-card'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { Sun,Moon,Blend } from 'lucide-react'
import { Link } from '@tanstack/react-router'

interface Strain {
  id: string
  name: string
  strainType?: string
  description?: string
  images?: string[]
  imageUrl?: string
}

interface StrainHoverCardProps {
  strain: Strain
}

export function StrainHoverCard({ strain }: StrainHoverCardProps) {
  return (
    <HoverCard>
      <HoverCardTrigger asChild>
        <Badge
          variant="secondary"
          className="text-[10px] h-5 px-1.5 font-normal gap-1 cursor-help hover:bg-muted-foreground/10"
        >
          {strain.strainType === 'SATIVA' && (
            <Sun className="h-3 w-3 text-amber-500" />
          )}
          {strain.strainType === 'INDICA' && (
            <Moon className="h-3 w-3 text-indigo-500" />
          )}
          {strain.strainType === 'HYBRID' && (
            <Blend className="h-3 w-3 text-emerald-500" />
          )}
          {strain.name}
        </Badge>
      </HoverCardTrigger>
      <HoverCardContent className="w-80">
        <div className="flex flex-col gap-3">
          <div className="flex justify-between space-x-4">
            <div className="space-y-1">
              <div className="flex items-center gap-2">
                <h4 className="text-sm font-semibold">{strain.name}</h4>
                <Badge
                  variant="outline"
                  className="text-[10px] h-5 px-1 font-normal gap-1"
                >
                  {strain.strainType === 'SATIVA' && (
                    <Sun className="h-3 w-3 text-amber-500" />
                  )}
                  {strain.strainType === 'INDICA' && (
                    <Moon className="h-3 w-3 text-indigo-500" />
                  )}
                  {strain.strainType === 'HYBRID' && (
                    <Blend className="h-3 w-3 text-emerald-500" />
                  )}
                  {strain.strainType}
                </Badge>
              </div>
              {strain.description && (
                <p className="text-sm text-muted-foreground line-clamp-3">
                  {strain.description}
                </p>
              )}
            </div>
            {(strain.images?.[0] || strain.imageUrl) && (
              <div className="shrink-0">
                <div className="h-10 w-10 rounded-md border bg-muted/50 overflow-hidden">
                  <img
                    src={strain.images?.[0] || strain.imageUrl}
                    alt={strain.name}
                    className="h-full w-full object-cover"
                  />
                </div>
              </div>
            )}
          </div>
          <Button variant="outline" size="sm" className="w-fit h-7 text-xs px-3" asChild>
            <Link to="/catalog/strains/$item" params={{ item: strain.id }} onClick={(e: React.MouseEvent) => e.stopPropagation()}>
              View Strain
            </Link>
          </Button>
        </div>
      </HoverCardContent>
    </HoverCard>
  )
}
